export default "__VITE_ASSET__f7cc70a2__"